import { render } from "./EditNonPharmaceuticalItem.vue?vue&type=template&id=41264c74"
import script from "./EditNonPharmaceuticalItem.vue?vue&type=script&lang=js"
export * from "./EditNonPharmaceuticalItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__